import React from 'react';
import { Button, Modal, Form, Input, InputNumber, Card, DatePicker, Col, Row, Space, Alert } from 'antd';
import { useParams, Navigate } from 'react-router-dom'
import SelectSearchInput from '../../utils/components/selectSearchInput';
import axios from '../../services/axios'
import moment from 'moment'

export default function UpdateOperation() {
    const [form] = Form.useForm();
    const { id }: any = useParams()
    const [clients, setClients] = React.useState([])
    const [devises, setDevises] = React.useState([])
    const [operation, setOperation] = React.useState({})
    const [loading, setLoading] = React.useState(false)
    const [redirect, setRedirect] = React.useState(false)
    const [cancelRedirect, setCancelRedirect] = React.useState(false) // NOUVEAU
    
    React.useEffect(() => {
        if (id) {
            getSingleOperation(id)
        }
        getClient()
        getDevise()
    }, [])

    const validateMessages = {
        required: '${label} est obligatoire',
        types: {
            email: "${label} n'est pas un email valide",
            number: "${label} n'est pas un nombre valide",
        },
        number: {
            range: '${label} doit être compris entre ${min} et ${max}',
        },
    };

    const getDevise = () => {
        axios.get('/devises')
            .then(response => {
                
                setDevises(response.data);
                setLoading(false)
            });
    }
    
    const getClient = () => {
        axios.get('/clients')
            .then(response => {
                
                setClients(response.data);
                setLoading(false)
            });
    }
    
    const onReset = () => {
        // form.resetFields(); // COMMENTÉ : on ne reset plus, on redirige
        setCancelRedirect(true); // NOUVEAU : activer la redirection
    }
    
    const config = {
        rules: [{ type: 'object' as const, required: true, message: 'Please select time!' }],
    };

    const onChange = (name: string, value: any) => {
        form.setFieldsValue({ [name]: value })
    }
    
    const getSingleOperation = (id: number) => {
        console.log('date :',);
        axios.get(`/operations/${id}`)
            .then(response => {
                
                setOperation(response.data)
                form.setFieldsValue({ 
                    'date_operation': moment(response.data.date_operation),
                    'numero_recu': response.data.numero_recu,
                    'nom_deposant': response.data.nom_deposant,
                    'tel_deposant': response.data.tel_deposant,
                    'motif': response.data.motif,
                    'taux': response.data.taux,
                    'taux_payer': response.data.taux_payer ?? response.data.taux,
                    'beneficiaire': response.data.beneficiaire,
                    'montant': response.data.montant,
                    'montant_convert': response.data.montant_sortie,
                    'type_operation': response.data.type_operation,
                    'type_paiement': response.data.type_paiement,
                    'pays_depart': response.data.pays_depart,
                    'pays_recuperation': response.data.pays_recuperation,
                    'client_id': response.data.client_id,
                    'devise_id': response.data.devise?.code,
                    'devise_sortie': response.data.devisesortie?.code,
                })
            })
            .catch(error => {
                console.log('error not found', error);
            });
    }
    
    const onSearch = (val: any) => {
        
    }
    
    const updateDepot = (data: any[], id: number) => {
        axios.post(`/operations/edit/${id}`, data)
            .then(function (response) {
                
                setRedirect(true)
                form.resetFields();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const onFinish = (values: any) => {
        setLoading(true);
        
        updateDepot(values, id)
        setLoading(false);
    };

    const onMontantChange = (value: number) => {
        const isValue = typeof value === 'number'
        if (isValue && form.getFieldValue('devise_id') && form.getFieldValue('devise_sortie') && form.getFieldValue('taux')) {
            getAmountConvert()
        }
        else console.log('error')
    }
    
    const getAmountConvert = () => {
        const data = {
            "devise_id": form.getFieldValue('devise_id'),
            "devise_sortie": form.getFieldValue('devise_sortie'),
            "montant": form.getFieldValue('montant'),
            "taux": form.getFieldValue('taux'),
        }
        axios.post(`operations/devises/convert`, data)
            .then((response) => {
                form.setFieldsValue({ 'montant_convert': response.data })
            }).catch((err) => {
                console.log(err);
            });
    }

    const op = operation as any
    
    return (
        <>
            <Row>
                <Col span={12} offset={6}>
                    <Card size="small" title={`Modification d'un ${op.type_operation ? op.type_operation : ''}`}  >
                        <Form
                            form={form}
                            name="nest-messages"
                            onFinish={onFinish}
                            validateMessages={validateMessages}
                        >
                            <Form.Item label="Numero reçu" style={{ marginBottom: 0 }} rules={[{ required: true }]}>
                                <Form.Item
                                    name='numero_recu'
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                >
                                    <Input placeholder="N° reçu" />
                                </Form.Item>
                                <Form.Item name='date_operation' style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}  >
                                    <DatePicker format="YYYY-MM-DD" placeholder="date" style={{ width: '100%' }} />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item name='client_id' label="Clients" rules={[{ required: true }]}>
                                <SelectSearchInput
                                    onChange={(v) => onChange('client', v)}
                                    data={clients}
                                    label='prenom'
                                    label2='nom'
                                    label3='telephone'
                                    valueLabel='id'
                                    onSearch={(value) => onSearch(value)}
                                    placeholder="Sélectionnez le client"
                                />
                            </Form.Item>

                            <Form.Item label="Déposant/Réceveur" style={{ marginBottom: 0 }} rules={[{ required: true }]}>
                                <Form.Item
                                    name='nom_deposant'
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                >
                                    <Input placeholder="nom déposant/réceveur" />
                                </Form.Item>
                                <Form.Item
                                    name='tel_deposant'
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                >
                                    <Input placeholder="téléphone déposant/réceveur" />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item name='pays_depart' noStyle>
                                <Input type="hidden" />
                            </Form.Item>
                            <Form.Item name='pays_recuperation' noStyle>
                                <Input type="hidden" />
                            </Form.Item>
                            <Form.Item name='type_paiement' noStyle>
                                <Input type="hidden" />
                            </Form.Item>
                            <Form.Item name='motif' noStyle>
                                <Input type="hidden" />
                            </Form.Item>

                            <Form.Item label="Devises *" style={{ marginBottom: 0 }} rules={[{ required: true }]}>
                                <Form.Item
                                    name='devise_id'
                                    rules={[{ required: true }]}
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                >
                                    <SelectSearchInput
                                        onChange={(v) => onChange('devise_id', v)}
                                        onSearch={(value) => onSearch(value)}
                                        label='code'
                                        valueLabel='code'
                                        data={devises}
                                        placeholder="Devise d'entrée"
                                    />
                                </Form.Item>
                                <Form.Item
                                    name='devise_sortie'
                                    rules={[{ required: true }]}
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}
                                >
                                    <SelectSearchInput
                                        onChange={(v) => onChange('devise_sortie', v)}
                                        onSearch={(value) => onSearch(value)}
                                        label='code'
                                        valueLabel='code'
                                        data={devises}
                                        placeholder="Devise de sortie"
                                    />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item initialValue={1} name='taux' label="Le taux" rules={[{ required: true }]}>
                                <InputNumber
                                    placeholder="taux"
                                    style={{ width: '100%' }}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
                                />
                            </Form.Item>

                            <Form.Item initialValue={1} name='taux_payer' label="Taux à payer" rules={[{ required: true }]}>
                                <InputNumber
                                    placeholder="taux à payer"
                                    style={{ width: '100%' }}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
                                />
                            </Form.Item>

                            <Form.Item name='beneficiaire' label="Bénéficiaire">
                                <Input placeholder="nom du bénéficiaire" />
                            </Form.Item>

                            <Form.Item name='montant' label="Montant" rules={[{ required: true }]}>
                                <InputNumber
                                    onChange={(value: any) => onMontantChange(value)}
                                    placeholder="Montant"
                                    style={{ width: '100%' }}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
                                />
                            </Form.Item>

                            <Form.Item
                                name='montant_convert'
                                label="M.Converti"
                            >
                                <InputNumber
                                    disabled
                                    placeholder="Montant converti"
                                    style={{ width: '100%' }}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
                                />
                            </Form.Item>

                            <Form.Item initialValue={op.type_operation} name='type_operation' noStyle>
                                <Input type="hidden" />
                            </Form.Item>

                            <Form.Item wrapperCol={{ offset: 8 }}>
                                <Space>
                                    <Button loading={loading} type="primary" htmlType="submit">
                                        Modifier
                                    </Button>
                                    <Button htmlType="button" onClick={onReset}>
                                        Annuler
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col >
            </Row >
            {
                redirect ? (<Navigate to={`/${op.type_operation}`} replace />) : ''
            }
            {
                cancelRedirect ? (<Navigate to={`/${op.type_operation}`} replace />) : ''
            }
        </>
    );
}